import React from "react";
import FlashMessage from "react-native-flash-message";

export function ToastHost() {
  return (
    <FlashMessage
      position="top"
      floating
      statusBarHeight={40}
      style={{
        zIndex: 99999,
        elevation: 99999,
      }}
    />
  );
}
